import productMedia from "./product-media";
/* import hoverOnZoom from "./hover-zoom";
import productVideo from "./product-video"; */

/**
 * Inject new image / images
 *
 * @param {HTMLElement} param0 - New data images from section rendering API
 * @param {String} className - Where mount new <product page> or <product card>
 * @param {HTMLElement} parent - Parent principal
 */
function innerImages(images, container) {
  const media = container;

  media.replaceChildren();
  media.innerHTML = images.innerHTML;
  media.classList.remove('opacity');
}

/**
 * DYNAMIC SLIDER
 *
 * @param {HTMLElement} ElementHook - Element hook
 * to update images after change event
 * @param {HTMLElement} images - HTML from section rendering
 *
 * @author Andres Briñez
 * @author Cristian Velasco
 *
 * @version 2.0
 */
export const renderDynamicSlider = async (container, images) => {
  if (!container || !images) return;

  innerImages(images, container);
  productMedia();

  /* hoverOnZoom();
  productVideo(); */
};

export const variantToSlide = (argElement) => {
  if (!argElement) { return }
  let variantName = [];
  const data = document.querySelector(argElement)
  const variantesRaw = data.dataset.variants.replace(/\'/gm, '"');
  const k = variantesRaw.lastIndexOf(',');
  const variantes = JSON.parse(variantesRaw.substr(0, k) + variantesRaw.substr(k + 1))
  variantes.forEach((e) => {
    const item = document.querySelectorAll(`[name="${ e }"]`)
    if (item.length == 1) {
      variantName.push(item[0].value)
    } else if (item.length > 1) {
      item.forEach((e) => {
        if (e.checked) {
          variantName.push(e.value)
        }
      })
    }
  })
  variantName = variantName.toString().replace(',', ' / ')

  const jsonRaw = data.dataset.json.replace(/\'/gm, '"');
  const l = jsonRaw.lastIndexOf(',');
  const jsonVariants = JSON.parse(jsonRaw.substr(0, l) + jsonRaw.substr(l + 1))
  const selectVariantId = jsonVariants[variantName];
  const sliderConainer = document.querySelector('#product-media-js')
  if (!sliderConainer) { return }
  const {slides} = sliderConainer.swiper
  slides.forEach((e) => {
    if (e.dataset.id == selectVariantId) {
      sliderConainer.swiper.slideTo(e.dataset.swiperSlideIndex)
    }
  })
}
